import * as config from 'config';

import {
  CreateCustomerAttributes,
  Customer,
  CustomerResponse
} from 'models/customer';
import { JsonData } from 'models/jsonApi';
import {
  getCountryCodeOrDefault,
  getLanguageCodeOrDefault
} from 'utils/localizationUtils';
import {
  apiFetch,
  buildMetaForward,
  defaultHeaders
} from 'utils/fetchUtils/fetchUtils';
import { EMAIL_VERIFICATION, LOGIN } from 'router/routes';

export async function signup(
  customer: CreateCustomerAttributes,
  meta?: JsonData
): Promise<Customer> {
  const { email, phoneNumber, country, language, type, captchaCode } = customer;
  const url = `${config.backendApi}/signup`;

  const json = await apiFetch<CustomerResponse>(url, {
    headers: defaultHeaders,
    method: 'POST',
    body: JSON.stringify({
      data: {
        type: 'signup',
        attributes: {
          ...customer,
          country: country ? getCountryCodeOrDefault(country) : undefined,
          language: language ? getLanguageCodeOrDefault(language) : undefined,
          captchaText: captchaCode,
          type,
          eContact: {
            emailContacts: [
              {
                emailAddress: email
              }
            ],
            phoneContacts: phoneNumber
              ? [{ phoneNumber: phoneNumber }]
              : undefined
          }
        }
      },
      meta: {
        ...meta,
        brand: config.brand,
        forward: buildMetaForward(EMAIL_VERIFICATION)
      }
    })
  });

  return json.data;
}

export async function verifyCustomer(
  email: string,
  verificationCode: string
): Promise<void> {
  const url = `${config.backendApi}/signup/verify-customer`;

  await apiFetch(url, {
    headers: defaultHeaders,
    method: 'POST',
    body: JSON.stringify({
      data: {
        type: 'signup',
        attributes: {
          email,
          verificationCode
        }
      }
    })
  });
}

export async function resendCustomerVerification(
  email: string,
  iprId?: string
): Promise<void> {
  const url = `${config.backendApi}/signup/resend-customer-verification`;

  await apiFetch(url, {
    headers: defaultHeaders,
    method: 'POST',
    body: JSON.stringify({
      data: {
        type: 'signup',
        attributes: {
          email
        }
      },
      meta: {
        brand: config.brand,
        forward: buildMetaForward(EMAIL_VERIFICATION),
        ...(iprId && {
          product: {
            iprId
          }
        })
      }
    })
  });
}

export async function resendUserVerification(email: string): Promise<void> {
  const url = `${config.backendApi}/signup/resend-user-verification`;

  await apiFetch(url, {
    headers: defaultHeaders,
    method: 'POST',
    body: JSON.stringify({
      data: {
        type: 'signup',
        attributes: {
          email
        }
      },
      meta: {
        brand: config.brand,
        forward: buildMetaForward(LOGIN)
      }
    })
  });
}
